import Link from "next/link";
import React from "react";
import { FiChevronRight } from "react-icons/fi";

export interface BreadcrumbsProps {
  data: {
    href: string;
    name: string;
  }[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ data }) => {
  return (
    <nav
      aria-label="breadcrumbs"
      className="p-1 font-roboto text-body-1-300 text-neutral-400 last:*:text-body-1-400 last:*:text-primary-600 last:*:hover:text-primary-600 sm:space-x-1 [&_*:not(:nth-last-child(-n+3))]:hidden sm:[&_*:not(:nth-last-child(-n+3))]:inline"
    >
      {/* Always show home */}
      <Link
        key={`breadcrumb-home`}
        className="inline hover:text-body-1-400 hover:text-neutral-500"
        href={"/"}
      >
        Home
      </Link>
      {data.map((step) => (
        <React.Fragment key={`breadcrumb-${step.name}-${step.href}`}>
          <FiChevronRight className="mx-1 mb-[2px] inline sm:ml-0 sm:mr-0" />
          <Link
            href={step.href}
            className="inline hover:text-body-1-400 hover:text-neutral-500"
          >
            {step.name}
          </Link>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
